var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.908 2.75487L9.51048 0.101137C9.38878 -0.0337124 9.19314 -0.0337124 9.07143 0.101137C8.94972 0.235987 8.94972 0.452759 9.07143 0.587608L10.939 2.65684H0.311949C0.139567 2.65684 0 2.81148 0 3.00247C0 3.19393 0.139567 3.34857 0.311949 3.34857H10.9386L9.07101 5.41228C8.94931 5.54713 8.94931 5.7639 9.07101 5.89875C9.13207 5.9664 9.21058 6 9.292 6C9.37299 6 9.45192 5.9664 9.51298 5.89875L11.911 3.2418C12.0302 3.10925 12.0302 2.89018 11.908 2.75487Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.23404e521b165fe325791f51b6f54121.svg";
export { ForwardRef as ReactComponent };